// extracted by mini-css-extract-plugin
export default {"root":"_404page_root__Fexjs","label":"_404page_label__h3ysh","description":"_404page_description__W9dK1","title":"_404page_title__66Qac"};